<script>
/**
 * ****************************************************************************
 * @description     :   PageNotFound page content
 * @created at      :   2022/04/21
 * @created by      :   ANS874 – quanhvm@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import { mapActions, mapState } from 'vuex';
/**
 * Import template
 */

import template from './template.html';
import TableList from '../../components/tableList';

/**
 * Define content of sales office master page
 */
var MiddleSide = {
    template: template,
    components: { TableList },
    props: {
        onSelectRow: Function
    },
    computed: {
        ...mapState('ra201000v', ['condition', 'resultSearch'])
    },
    methods: {
        ...mapActions('ra201000v', ['search', 'edit', 'delete']),
        doSearch() {
            this.search(this.condition);
        },
        onEditData(data, index) {
            this.edit({
                actioncode: 'U',
                clientcode: data.clientcode,
                shitaukecode: data.shitaukecode,
                shitaukename: data.shitaukenameEdit,
                index: index
            });
        },
        onDeleteData(data, index) {
            this.delete({
                index: index,
                shitaukecode: data.shitaukecode
            });
        },
        onSelectData(item) {
            if (this.onSelectRow) {
                this.onSelectRow(item);
            }
        }
    }
};
export default MiddleSide;
</script>
